import { ButtonComponentProps } from "./types/Button";
import { Button } from "@mantine/core";

export function ButtonComponent(props: ButtonComponentProps) {
  const { children } = props;

  return <Button {...props}>{children}</Button>;
}
